import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  text-align: center;
  margin: 60px;

  @media (max-width: 650px) {
    margin: 45px 20px;
  }

  img {
    max-width: 100%;
    transform: translate(20px, 20px);
    filter: saturate(0) brightness(1.1);
    mix-blend-mode: multiply;
    -o-object-fit: cover;
    object-fit: cover;
    width: 600px;
  }
`;

const ImgWrapper = styled.div`
  background: var(--nude-200);
  display: inline-block;
  margin: 0 auto;
`;

export const MarketingImageSection = ({ img, alt = 0 }) => {
  if (!img) {
    return null;
  }
  return (
    <Wrapper>
      <ImgWrapper>
        <img src={img} alt="" />
      </ImgWrapper>
    </Wrapper>
  );
};
